import * as classes from "./UpgradeButton.module.css";
import { ReactNode } from "react";

interface UpgradeButtonProps {
    category: ReactNode;
    categoryHsl: string;
    name: ReactNode;
    valueCurrent: ReactNode;
    valueNext: ReactNode;
    cost: ReactNode;
    disabled?: boolean;
}

export function UpgradeButton(props: UpgradeButtonProps) {
    let {
        category,
        categoryHsl,
        name,
        valueCurrent,
        valueNext,
        cost,
        disabled = false,
    } = props;

    return (
        <button
            className={classes.root}
            style={{ "--inline-category-hsl": categoryHsl }}
            disabled={disabled}
        >
            <span className={classes.description}>
                <span className={classes.category}>{category}</span>
                <span>{name}</span>
            </span>
            <span className={classes.valueContainer}>
                <span className={classes.valueCurrent}>{valueCurrent}</span>
                <span>{valueNext}</span>
            </span>
            <span className={classes.valueContainer}>{cost}</span>
        </button>
    );
}
